import { render, staticRenderFns } from "./ElementFactTableColumn.vue?vue&type=template&id=6c0bc684&scoped=true"
import script from "./ElementFactTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementFactTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementFactTableColumn.vue?vue&type=style&index=0&id=6c0bc684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0bc684",
  null
  
)

export default component.exports